import { render, staticRenderFns } from "./changeTeamName.vue?vue&type=template&id=8ffbc0b6&scoped=true&"
import script from "./changeTeamName.vue?vue&type=script&lang=js&"
export * from "./changeTeamName.vue?vue&type=script&lang=js&"
import style0 from "./changeTeamName.vue?vue&type=style&index=0&id=8ffbc0b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffbc0b6",
  null
  
)

export default component.exports